import { ViewModelCritica } from './../models/viewModelCritica';
import { ViewModelResultadoEnvio } from './../models/viewModelResultadoEnvio';
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { ViewModelEnviaCobranca } from "../models/enviaCobranca.model";
import { ViewModelEnviaCobrancaNovo } from '../models/enviaCobrancaNovo.model';
import { ViewModelCriticaNovo } from '../models/viewModelCriticaNovo';


export class GerenciadorRegistroCobrancaService {

    //private strAction = 'api/RegistroCobranca';

    constructor(
        httpClient: HttpClient,
        private http: HttpClient,
        private route: Router) {
            
    }

    Post(viewModelEnviaCobrancaNovo: ViewModelEnviaCobrancaNovo) {    
        return this.http.post<void>(`${environment.TrustapiAreaRestrita}/`, viewModelEnviaCobrancaNovo);
    }

    getResultadoEnvio(vencimento: string){
        return this.http.get<ViewModelResultadoEnvio>(`${environment.TrustapiAreaRestrita}ResultadoEnvio/${vencimento}`);
    }

    getRetornaCriticaEnvioEmail(vencimento: string){
        return this.http.get<ViewModelCriticaNovo[]>(`${environment.TrustapiAreaRestrita}RetornaCriticaEnvioEmail/${vencimento}`);
    }

}